import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getIcon } from 'utils/get-icon'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.4rem',
    color: '#000000 !important',
  },
}))

const getDefinition = (definition: string | undefined) => {
  const classes = useStyles()

  if (definition === undefined) {
    return <span></span>
  }

  const def = JSON.parse(definition)

  if (def?.nextUpdate) {
    return <span>{def.nextUpdate}</span>
  } else if (def?.icon && def?.contractParamName) {
    return (
      <span className={classes.root}>
        {getIcon(def.icon)} {formatContractParamName(def.contractParamName)}
      </span>
    )
  } else {
    return <span></span>
  }
}

const formatContractParamName = (name: string) => {
  if (!name) {
    return ''
  }

  return name
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export default getDefinition
